import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useReducer } from "react";
import type { Nullable } from "../@types/generic";

type PathParams = {
    pathname: string;
    page: Nullable<string>;
};

export const useIsPageChange = (): boolean => {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const page = searchParams.get("page");

    const [state, dispatch] = useReducer(
        (prevState, newState: PathParams) => ({
            isPageChange:
                prevState.pathname !== newState.pathname ||
                prevState.page !== newState.page,
            page,
            pathname,
        }),
        { isPageChange: false, page, pathname }
    );

    useEffect(() => {
        dispatch({ pathname, page });
    }, [pathname, page, state.isPageChange]);

    return state.isPageChange;
};
